import React from 'react'
import { IonBackButton, IonIcon, IonRow, isPlatform } from '@ionic/react'
import classNames from 'classnames'

import Button from '../../Button'
import { getDirMode, isRTL } from '../../../../platform'
import strings from '../../../../../strings'

import { chevronBack } from 'ionicons/icons'

import './styles.less'

interface Props {
	onBackButton?: React.MouseEventHandler<HTMLIonButtonElement>
	prevPagePath: string
	className?: string
	ariaLabel?: string
	icon?: string
	text: string
	children?: React.ReactNode
}

const BackButton: React.FC<Props> = ({
	onBackButton,
	className,
	ariaLabel = strings.accessibility_go_back,
	icon = chevronBack,
	text,
}) => {
	if (onBackButton) {
		return (
			<Button
				fill="clear"
				onClick={onBackButton}
				ariaLabel={ariaLabel}
				className={classNames('header-back-button', className, {
					rtl: isRTL(),
					ios: isPlatform('ios'),
				})}
			>
				<IonRow dir={getDirMode()}>
					{icon ? <IonIcon icon={icon} /> : null}
					{text}
				</IonRow>
			</Button>
		)
	} else {
		// `IonBackButton` is using a different color on iOS. This make sure the color is consistent
		return <IonBackButton style={{ display: 'block', '--color': 'currentColor' }} icon={icon || ''} text={text} />
	}
}

export default React.memo(BackButton)
